module.exports = __webpack_public_path__ + "img/search.d3efb384.svg";